
import React from 'react';

const SortingArrowIcon = ({ width = 70, height = 70, color = "#FE531F" }) => {
    return (
        <svg 
        width={width} 
        height={height} 
        viewBox="0 0 70 70" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="35" cy="35" r="33.5" fill="white" stroke={color} stroke-width="3"/>
        <path d="M21.5967 26.7891H48.4033L34.9854 49.3184L21.5967 26.7891Z" fill={color}/>
        </svg>
        

    );
};

export default SortingArrowIcon;


